import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
// material ui components
import { Box } from '@mui/material';

// application components
import LueferIcon from './luefterSvg'
import theme from '../theme'

const styles = {
    wohnZimmerSvg: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    wohnZimmerSvgSmall: {
        width: 'auto',
        height: 'auto',
    },
    wohnZimmerSvgLarge: {
        padding: '3px 3px',
    },
    iconLarge: {
        position: 'relative',
        left: '-10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    iconSmall: {
        position: 'relative',
        left: '-5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    luefterIcon: {
        display: 'flex',
        alignItems: 'flex-end',
    },
    barSmall: {
        width: 0,
        height: 0,
        borderTop: `3px solid ${ theme.palette.svgs.fanSVG }`,
        borderLeft: '2px solid transparent',
        opacity: '0.5',
        marginBottom: 1,
    },
    barLarge: {
        width: 0,
        height: 0,
        borderTop: '12px solid #e2e2e2',
        borderLeft: '5px solid transparent',
        opacity: '0.5',
        marginBottom: 4,
    },
    activeSmall: {
        borderTopColor: theme.palette.svgs.fanSVG,
        borderRightColor: `${ theme.palette.svgs.fanSVG } !important`,
        borderLeftColor: 'transparent',
        opacity: '1',

    },
    activeLarge: {
        borderTopColor: 'white',
        borderRightColor: 'white !important',
        borderLeftColor: 'transparent',
        opacity: '1',

    },
}

const wohnZimmerSvg = ({ classes, level, active, iconSize }) => {
    const LevelItems = []
    const currentActive = level - active

    const lineColor = (item)=>{
        if (item>currentActive){
            return("11px solid #fff")
        }else{
            return("11px solid rgba(0,0,0,0.2)")
        }  
    }

    for (let item = 1; item <= level; item += 1) {
        LevelItems.push(<Box
            key={item}
           style={{
            borderTop: lineColor(item),
            borderLeft: "5px solid transparent",
            height: 0,
            width: `${(60-(item*6))}px`,
            marginBottom:5
           }}
        />)
    }
   

    return (
        <Box style={styles.wohnZimmerSvg} sx={iconSize?styles.wohnZimmerSvgSmall:styles.wohnZimmerSvgLarge}>
            <div style={styles.luefterIcon }>
                <LueferIcon width={(iconSize) ? 10 : 32} height={(iconSize) ? 10 : 32} color={(iconSize) ? '#E8771A' : '#fff'}/>
            </div>
            <div style={(iconSize) ? styles.iconSmall : styles.iconLarge}>
                {LevelItems}
            </div>
        </Box>
    )
}

wohnZimmerSvg.defaultProps = {
    iconSize: false,
}

wohnZimmerSvg.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    level: PropTypes.number.isRequired,
    active: PropTypes.number.isRequired,
    iconSize: PropTypes.bool,
}

export default wohnZimmerSvg
